import { GameEvent } from '@/types/Events'
import useSocket from './useSocket'
import { useHelpers } from './useHelpers'
import type { CardT, GameStateT } from '@/types/Game'
import { useGameStore } from '@/stores/game'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/stores/app'

export const useSocketEvents = () => {
  const { printEvent } = useHelpers()
  const { updateGameState, updateDeferredGameState } = useGameStore()
  const { allCards } = storeToRefs(useGameStore())
  const { isDeferringState } = storeToRefs(useAppStore())
  const socket = useSocket()

  socket.on(GameEvent.GameStateChanged, (state: GameStateT) => {
    if (isDeferringState.value) {
      updateDeferredGameState(state)
    } else {
      updateGameState(state)
    }
    printEvent(GameEvent.GameStateChanged, state, 'log')
  })

  socket.on(GameEvent.CardsUpdated, (cards: CardT[]) => {
    allCards.value = cards
    printEvent(GameEvent.CardsUpdated, cards, 'log')
  })

  return {}
}
